<template>
	<div id="test">
		<div class="section">
			<div class="library-info">
				<h2 class="section-title"></h2>
				<img src="@/assets/analisi.png" style="display:block; max-width:100%; margin: 0 auto;" align="center">
			</div>
		</div>
		<div class="divprova">
			<a href="#piani"><button class="provagratuita" id="provagratuita"><b>ACQUISTA ORA</b></button></a>
		</div>
		<div class="container-desktop pad-l">
			<div class="p-relative">
				<div class="info">
						<span style="color: rgb(255, 224, 16);"><b>La corsa è uno dei movimenti più naturali nell'essere umano</b></span>, radicato nella nostra evoluzione e fisiologia. 
						Fin dai tempi più antichi, i nostri antenati correvano per cacciare, sfuggire ai predatori e spostarsi su lunghe distanze. 
						Questa capacità ha giocato un ruolo cruciale nella sopravvivenza della specie umana. 
						<br><br>MA, c’è un ma molto grande, ovvero che <span style="color: rgb(255, 224, 16);"><b>al giorno d'oggi le persone hanno dimenticato come si corre!</b></span> 
						<br><br>Senza la consapevolezza del proprio corpo e del proprio movimento, è facile cadere in errori tecnici che, se ripetuti, 
						possono portare a una corsa inefficace e dannosa. 
						<br><br>Per questo dopo studi ed esperienze sul campo abbiamo creato un percorso che, partendo da un <span style="color: rgb(255, 224, 16);"><b>analisi biomeccanica professionale</b></span> della corsa, 
						ti <span style="color: rgb(255, 224, 16);"><b>ri-insegnerà a correre in maniera naturale e senza infortuni.</b></span>
				</div>
			</div>
		</div>
		<div class="divprova">
			<a href="#analisi"><button class="provagratuita" id="provagratuita"><b>Prenota subito la tua CALL GRATUITA!</b></button></a>
		</div>
		<blockquote>
		<i>La corsa è un'espressione naturale della nostra umanità, un movimento innato che porta con sé 
		innumerevoli benefici per la salute fisica e mentale. Tutti dovrebbero saper correre perché rappresenta 
		una delle forme più pure e potenti di esercizio, capace di migliorare la qualità della vita e connetterci 
		alle nostre radici più profonde."</i>
		</blockquote>
		<div class="container-desktop pad-l">
			<h2 class="section-title">Chi Siamo</h2>
			<div class="p-relative">
				<img src="@/assets/team.png" style="display:block; max-width:100%; margin: 0 auto;" align="center">
			</div>
		</div>
		<div class="divprova">
			<a href="#piani"><button class="provagratuita" id="provagratuita"><b>ACQUISTA ORA</b></button></a>
		</div>
		<div class="container-desktop pad-l imgdiv" style="padding: 0;">
			<h2 class="section-title"></h2>
			<img class="mobileimg" src="@/assets/comefunziona_mobile.png" style="max-width:100%; margin: 0 auto;" align="center">
			<img class="deskimg" src="@/assets/comefunziona.jpg" style="max-width:100%; margin: 0 auto;" align="center">
		</div>
		<br>
		<div class="divprova">
			<a href="#analisi"><button class="provagratuita" id="provagratuita"><b>Prenota subito la tua CALL GRATUITA!</b></button></a>
		</div>

		<div class="container-desktop pad-l">
			<h2 class="section-title">Perché Scegliere la Nostra Analisi della Corsa ?</h2>
			<div class="p-relative">
					<ul style="font-size:1.2em;" class="testotest">
						<li><span style="color: rgb(255, 224, 16);"><b>Prevenzione degli Infortuni:</b></span> Identifica e correggi i movimenti che possono causare lesioni.</li>
						<li><span style="color: rgb(255, 224, 16);"><b>Miglioramento delle Prestazioni:</b></span> Ottimizza la tua tecnica per correre più velocemente e con meno sforzo.</li>
						<li><span style="color: rgb(255, 224, 16);"><b>Accesso da Ovunque:</b></span> Ricevi un'analisi professionale senza dover uscire di casa.</li>
						<li><span style="color: rgb(255, 224, 16);"><b>Supporto Continuo:</b></span> Assistenza e follow-up inclusi per garantire progressi continui.</li>
					</ul>
			</div>
		</div>

		<!--<div class="container-desktop pad-l">
			<h2 class="section-title">Testimonianze</h2>
			<div class="p-relative">
					<p></p>
			</div>
		</div>-->

		<div class="container-desktop pad-l">
			<h2 class="section-title" id="piani">Scegli il Tuo Piano</h2>
			<div class="p-relative">
					<p class="testotest">
					Prima di vedere quanto costano i nostri pacchetti vorrei dirti quanto potrebbe costarti 
					NON fare l’analisi della corsa: <span style="color: rgb(255, 224, 16); text-transform: uppercase;"><b>ogni anno l’80% dei corridori si infortuna</b></span> e questo gli 
					obbliga a spendere molti soldi in terapie costose che faranno guarire il sintomo, ma non la 
					causa dell’infortunio portandoli in un circolo senza fine, come un cane che si morde la coda.
					<br><br><span style="color: rgb(255, 224, 16);"><b>Facendo UNA SOLA VOLTA l’analisi biomeccanica della corsa prenderai subito consapevolezza 
					dei tuoi errori</b></span> e vedrai già la differenza diminuendo il rischio di infortuni, rischio che 
					potrebbe arrivare vicino allo ZERO se oltre all’analisi ti farai seguire anche con programmi 
					personalizzati per migliorare la tua tecnica.
					</p>
			</div>
			<div class="p-relative">
					<div class="bar">
						<Card class="bg-darker" title="Starter" :image="require('@/assets/analisibase.png')"><p>Include analisi video con rapporto dettagliato e consigli personalizzati.<br><br><br><br><p class="prezzo">95€</p><p class="buy"><a href="https://buy.stripe.com/8wM7uA1yV7jdf7200v"><button>Acquista</button></a></p></Card>
						<Card class="bg-darker" title="Avanzato" :image="require('@/assets/avanzato.png')"><p>Include analisi video, rapporto dettagliato, programma di tecnica personalizzato con video esercizi per migliorare la tecnica e follow-up.<br><br><p class="prezzo">160€</p><p class="buy"><a href="https://buy.stripe.com/eVa7uAgtPgTNgb65kQ"><button>Acquista</button></a></p></Card>
						<Card class="bg-darker" title="Elite" :image="require('@/assets/completo.png')" id="test"><p>Include tutto il Pacchetto Avanzato, più 3 sessioni di coaching online o in presenza.<br><br><br><p class="prezzo">350€</p><p class="buy"><a href="https://buy.stripe.com/5kA02891nfPJ7EAaFb"><button>Acquista</button></a></p></Card>
					</div>
				</div>
					<p>
					*Le analisi verrano fatte da un nostro esperto entro 72 ore, queste analisi richiedono molto 
					tempo in quanto, essendo professionisti, ci teniamo a fare un lavoro al massimo livello e 
					molto dettagliato.
					</p>
			
		</div>

		<div class="container-desktop pad-l">
			<h2 class="section-title">Domande Frequenti (FAQ)</h2>
			<div class="p-relative">
					<p class="testotest">
						<i><b>Quali dispositivi posso usare per registrare il video della mia corsa?</b></i>
						<br>Puoi usare qualsiasi smartphone o videocamera che riprenda in alta definizione.
						<br><br>
						<i><b>Quanto tempo ci vuole per ricevere l'analisi?</b></i>
						<br>Di solito forniamo il rapporto dettagliato entro 72 ore dalla ricezione del video.
						<br><br>
						<i><b>Posso fare altre domande dopo aver ricevuto il rapporto?</b></i>
						<br>Assolutamente! Offriamo supporto continuo via email per rispondere a qualsiasi dubbio o domanda.
					</p>
			</div>
		</div>
		
		<div class="container-desktop pad-l" style="background: #101418; max-width:100%;">
			<h2 class="section-title">Pronto a Migliorare la Tua Corsa?</h2>
			<h2 align="center">Non aspettare oltre! Prenota ora la tua analisi della corsa online e inizia 
				il tuo percorso verso una tecnica migliore e prestazioni ottimali.</h2>
			<div class="p-relative">

			</div>
		</div>
		<br><br>
		<div class="divprova">
			<a href="#piani"><button class="provagratuita" id="provagratuita"><b>ACQUISTA ORA</b></button></a>
		</div>
		<div class="container-desktop pad-l">
				<h2 id="analisi" class="section-title">Prenota ora la tua Call gratuita!</h2>

				<div class="grid">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitTrial">
							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
									<input type="text" v-model="formData.firstName" name="first_name" placeholder="Nome" id="nomeprova" required/>
								</div>

								<div class="form-input">
									<label>Cognome</label>
									<input type="text" v-model="formData.lastName" name="last_name" placeholder="Cognome" required/>
								</div>

								<div class="form-input">
									<label>Email</label>
									<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>

								<div class="form-input">
									<label>Cellulare</label>
									<input type="number" v-model="formData.phone" name="phone" placeholder="Cellulare" required/>
								</div>

								<div class="form-input">
									<label>Messaggio (opzionale)</label>
									<textarea rows="5" v-model="formData.message" name="message" placeholder="..."></textarea>
								</div>

								<div class="form-input">
									<label>Fascia oraria per essere chiamato</label>
									da <input type="time" v-model="formData.when" name="when" required/>
									a <input type="time" v-model="formData.when2" name="when2" required/>
								</div>

								<div class="submit">
									<button id="bottoneprova">PRENOTA</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
	</div>

</template>
<script>
import VideoCard from '@/components/library/VideoCard'
import Card from '@/components/home/Card'
import ShowMore from '@/components/global/ShowMore'
import About from '@/components/home/About'
import api from '@/api'

export default {
	name: 'shop',

	components: {
		VideoCard,
		Card,
		About,
		ShowMore
	},

	data() {

		return {
			/// Authenticated user
			bShowBlogNav: false,
			formData: {
				firstName: '',
				lastName: '',
				email: '',
				phone: '',
				service: 'ANALISI',
				message: '',
				when: '',
				when2: ''
			}
		}
	},

	created(){
     },

	computed: {
		/**
		 * 
		 */
	},

	methods: {
		/**
		 * Send trial request
		 */
		async submitTrial() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/trialcorsa', /* data */{
					first_name: this.formData.firstName,
					last_name: this.formData.lastName,
					email: this.formData.email,
					phone: this.formData.phone,
					service: this.formData.service,
					message: this.formData.message,
					when: this.formData.when,
					when2: this.formData.when2
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('thankyou')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		}
	},

	mounted() {

		window.scrollTo(0, 0)
	},

}

</script>

<style lang="stylus" scoped>
.imgdiv
	.mobileimg
		display block

		@media (min-width: unit(1201, px))
			display none

	.deskimg
		display block

		@media (max-width: unit(1200, px))
			display none



.info
	padding 1em 1.5em

	background repeating-linear-gradient(45deg, rgba(dark, 0), rgba(dark, 0) 1.6em, rgba(dark, 0.5) 1.6em, rgba(dark, 0.5) 3.2em)

	font-family fontSans
	font-size 1.2em

.testotest
	font-size 1.2em
	text-align justify

	img
		margin 1em

		@media (max-width: unit(767, px))
			float none
			display block
			margin 1em auto

blockquote
	font-size 1.2em
	margin 0 auto
	background #101418
	padding 3em 8em

	@media (max-width: unit(767, px))
		padding 1em 2em

.bar
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.bar2
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.filtro
	width 100%
	background #101418
	height 3em
	margin-bottom 3em

	@media (max-width: unit(767, px))
		height 100%
		padding-bottom 0.7em

.catcont
	width 520px
	margin 0 auto
	position relative
	display flex
	padding-top 0.6em

	@media (max-width: unit(767, px))
		width 100%
		display grid

.menu-button
			height 100%
			margin 0 auto
			display none 

			@media (min-width: unit(768, px))
				display none

			>button
				height 100%

				display flex
				align-items center

				border none

				background-color transparent
				color #dcdcdc

				font-size 2em

				&:focus
					outline none
				&:hover
					background-color mix(darkish, dark)

.mobileblog
	display none

	&.show
		display none

.categoria
	text-transform uppercase
	font-size 1.1em
	font-weight bold
	margin 0 auto

	@media (max-width: unit(767, px))
		color red	

.link
	text-decoration none 
	color #dcdcdc
	transition 0.2s ease

.link:hover
	color #ffe010


.up
	position fixed
	bottom 0
	left 0
	margin-left 1em
	margin-bottom 1em
	width 2.5em
	height 2.5em
	border-radius 2.5em
	background #ffe010
	z-index 9999

.progselect
	max-width 570px
	margin 0 auto
	text-align center

	.progworkout
		max-width 490px
		margin 0 auto
		p
			text-align left
			font-size 1.2 em
			margin-left 0.7em

.divprogramma
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	@media (max-width: unit(560, px))
		grid-template-columns auto

.programma
	padding 0.4em 0.6em
	border none
	border-bottom 2px solid transparent
	box-sizing border-box
	background-color darkish
	color light
	font-size 1.2em

.divprova
	max-width 100%
	padding 2em
	text-align center

.provagratuita

	padding 0.6em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.4em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.presdesc
	list-style-type none

	li:before
		content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
		color: #ffe010; /* Change the color */
		font-weight: bold; /* If you want it to be bold */
		display: inline-block; /* Needed to add space between the bullet and the text */
		width: 1em; /* Also needed for space (tweak if needed) */
		margin-left: -1em; /* Also needed for space (tweak if needed) */

.divpres
	text-align center

	img
		display block
		margin 0 auto

.divbox
	display grid
	grid-template-columns auto
	grid-gap 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto
	
	ul
		text-transform uppercase
		font-weight bold

.divul
	text-align left
	margin 0 auto

.grid
	display grid
	grid-template-columns 3fr 2fr

	@media (max-width: unit(media-phone-max, px))
		display block

	.fixed-ratio
		position relative

		padding-bottom 56%
		box-sizing border-box

		.map
			position absolute
	
	.contact-form
		grid-column 1/5

		margin 1.5em
		padding 2em

		background-color dark

		.title
			font-size 1.2em
		
		.input-grid
			margin-top 1.5em

			.form-input
				margin 0.5em 0

				box-sizing border-box
				
				label
					display block

					margin-bottom 0.4em

					font-size 0.8em

				input
					width 100%

					display block
				
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
				
				select
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em
				
				textarea
					width 100%

					display block

					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-family fontSans
					font-size 1.1em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
			
			.submit
				margin-top 4em

				button
					width 100%

					padding 0.6em
					border none

					background-color primary
					color dark

					font-family fontSans
					font-size 1.3em

					cursor pointer

					transition 0.2s ease

					&:focus
						outline none

	.how
		.where
			margin-bottom 1em

			font-size 1.1em

	.contacts
		.mail
		.phone
			color lighten(secondary, 20%)

			text-decoration none

			&:hover
				text-decoration underline

	.socials
		.social-list
			display flex
			align-items center

			margin-top 0.2em
			margin-left 0.2em

			font-size 1.4em

			>a
				padding 0.3em

				color light

				text-decoration none

				transition 0.15s ease

				&:hover
					border-radius 50%

					background-color dark

					&.fa-facebook
						color #30C0F0
					&.fa-instagram
						color #D080D0
</style>
